import * as React from 'react'

import { observer } from 'mobx-react'

import { Button } from '~/client/src/shared/components/Button/Button'
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  type DialogPortalContainer,
} from '~/client/src/shared/components/shadcn-ui/dialog'
import Spinner from '~/client/src/shared/components/Spinner/Spinner'
import Localization from '~/client/src/shared/localization/LocalizationManager'

interface IProps {
  isOpen: boolean
  onCancelClicked: () => void
  onDoneClicked: () => void
  title?: string
  doneTitle?: string
  cancelTitle?: string
  question?: string
  loading?: boolean
  doneDisabled?: boolean
  useRedConfirmationButton?: boolean
  portalContainer?: DialogPortalContainer
  contentClassName?: string
}

@observer
export default class ConfirmDialog extends React.Component<IProps> {
  public render() {
    const {
      isOpen,
      loading,
      doneDisabled,
      title,
      question,
      onDoneClicked,
      onCancelClicked,
      doneTitle,
      cancelTitle,
      children,
      useRedConfirmationButton,
      portalContainer,
      contentClassName,
    } = this.props

    return (
      <Dialog
        open={isOpen}
        onOpenChange={open => {
          if (!open) {
            onCancelClicked()
          }
        }}
        disablePointerDismissal
      >
        <DialogContent
          showCloseButton={false}
          portalContainer={portalContainer}
          className={contentClassName}
        >
          <DialogHeader>
            <DialogTitle>
              {title || Localization.translator.confirm}
            </DialogTitle>
            {question && <DialogDescription>{question}</DialogDescription>}
          </DialogHeader>

          {children}

          <DialogFooter>
            <Button
              variant="outline"
              size="lg"
              onClick={onCancelClicked}
              disabled={loading}
              data-testid="confirm-dialog-cancel"
            >
              {cancelTitle || Localization.translator.cancel}
            </Button>
            <Button
              variant={useRedConfirmationButton ? 'destructive' : 'default'}
              size="lg"
              onClick={onDoneClicked}
              disabled={loading || doneDisabled}
              data-testid="confirm-dialog-done"
            >
              {loading && (
                <span data-icon="inline-start" className="tw:inline-flex">
                  <Spinner size="sm" variant="white" />
                </span>
              )}
              {doneTitle || Localization.translator.done}
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>
    )
  }
}
